export default "__VITE_ASSET__BDqPFPEu__"